import PropTypes from 'prop-types'
import React, { Component } from 'react'

import StepNavItem from './StepNavItem'

export default class StepNav extends Component {
  static propTypes = {
    active: PropTypes.string,
    onChange: PropTypes.func,
    steps: PropTypes.array,
  }

  render() {
    const { steps, active, onChange } = this.props
    return (
      <ul className="steps">
        {steps.map((step) => (
          <StepNavItem
            onClick={onChange}
            active={active === step.key}
            key={step.key}
            value={step.key}
            title={step.title}
            dirty={step.dirty}
          />
        ))}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/StepNav.js